import { handleError } from "../../utils/Common/Constant";
import apiClient from "../Connection/Connection";
// get encryption key
export const generateEncryptionKey = async () => {
  try {
    const res = await apiClient.get("/fileEncryption/generateEncryptionKey");
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// decrypt file
export const getDecryptFile = async (fileName: string) => {
  try {
    const res = await apiClient.get(
      `/s3Upload/downloadFile?fileName=${fileName}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// getDecrypted key
export const generateDecryptKey = async (encryptedKey: string) => {
  try {
    const res = await apiClient.post("/fileEncryption/decryptKey", {
      encryptedKey,
    });
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// encrypt/decrypt helper functions
export const ab2b64 = (buf: any) => {
  const bytes = new Uint8Array(buf);
  let binary = "";
  for (let i = 0; i < bytes.length; i++)
    binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
};
export const b642ab = (b64: string) => {
  const binary = atob(b64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
};
export const importAesKey = (rawKeyBase64: any) => {
  const keyBytes = new Uint8Array(b642ab(rawKeyBase64));
  return crypto.subtle.importKey("raw", keyBytes, { name: "AES-GCM" }, false, [
    "encrypt",
    "decrypt",
  ]);
};
export const generateEncryptionKeyApi = async () => {
  const res = await generateEncryptionKey();
  return res?.data;
};
